import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const salesOrderFreightQueryAtom = createQueryAtomFactory(
  'trade.salesOrderFreights',
  (params: { salesOrderId: string }) => ({
    salesOrderFreights: {
      __args: {
        filter: {
          salesOrderId: params.salesOrderId,
        },
      },
      entries: {
        id: true,
        salesOrderId: true,
        carrierId: true,
        freightLaneId: true,
        rateFormula: true,
        rateVariableIds: true,
        chargebackFormula: true,
        chargebackVariableIds: true,
        fuelSurchargeFormula: true,
        fuelSurchargeVariableIds: true,
        fuelSurchargeMode: true,
        notes: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data) => data.salesOrderFreights.entries[0] ?? null,
  },
);
